
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M18 2c2.206 0 4 1.794 4 4v12c0 2.206-1.794 4-4 4H6c-2.206 0-4-1.794-4-4V6c0-2.206 1.794-4 4-4zm0-2H6a6 6 0 00-6 6v12a6 6 0 006 6h12a6 6 0 006-6V6a6 6 0 00-6-6z","data-original":"#000000"}}),_c('path',{attrs:{"d":"M12 18a1 1 0 01-1-1V7a1 1 0 012 0v10a1 1 0 01-1 1z","data-original":"#000000"}}),_c('path',{attrs:{"d":"M6 12a1 1 0 011-1h10a1 1 0 010 2H7a1 1 0 01-1-1z","data-original":"#000000"}})])])
          )
        }
      }
    